module.exports = __webpack_public_path__ + "static/media/30_plantilla_cuadrada_combo_simple_cp_gaseosas_pet_237_ccsa.ba51f780.png";